import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['copiedText', 'linkUrl'];

  copyText = () => {
    navigator.clipboard.writeText(this.linkUrlTarget.value);
    this.copiedTextTarget.hidden = false;
  };
}
